import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { deleteTicket } from "../../api/subscription";
import { paidBy } from "./TicketsFormPage";

const TicketTable = ({
  eventId,
  tickets = [],
  onDelete = () => {},
  ticketTypeFilter,
  setTicketTypeFilter,
  statusFilter,
  paidByFilter,
  setStatusFilter,
  setPaidByFilter,
}) => {
  const filteredTickets = useMemo(() => {
    return tickets.filter((t) => {
      const matchesType = ticketTypeFilter
        ? t.ticketTypeId?._id === ticketTypeFilter
        : true;
      const matchesStatus = statusFilter
        ? statusFilter === "null"
          ? t.paymentStatus == null
          : t.paymentStatus === statusFilter
        : true;
      const paidByType = paidByFilter
        ? t.paidBy === paidByFilter
        : true;
      return matchesType && matchesStatus && paidByType;
    });
  }, [tickets, ticketTypeFilter, statusFilter, paidByFilter]);

  const uniqueTicketTypes = useMemo(() => {
    return tickets.reduce((acc, item) => {
      acc[item?.ticketTypeId?._id] = item?.ticketTypeId?.name?.az;
      return acc;
    }, {});
  }, [tickets]);

  const sumOfPrices = filteredTickets.filter(item => item?.paidBy !== 'invitation').reduce(
    (acc, item) => acc + item?.ticketTypeId?.price,
    0
  );

  const countOfTickets = filteredTickets.length;

  return (
    <div className="mt-4 space-y-4">
      {/* Filters */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <select
          className="border p-2 rounded w-full"
          onChange={(e) => setTicketTypeFilter(e.target.value)}
          value={ticketTypeFilter}
        >
          <option value="">Bütün növlər</option>
          {Object.keys(uniqueTicketTypes).map((id) => (
            <option key={id} value={id}>
              {uniqueTicketTypes[id]}
            </option>
          ))}
        </select>

        <select
          className="border p-2 rounded w-full"
          onChange={(e) => setStatusFilter(e.target.value)}
          value={statusFilter}
        >
          <option value="">Bütün statuslar</option>
          <option value="success">Uğurlu</option>
          <option value="failed">Uğursuz</option>
          <option value="null">Naməlum</option>
        </select>

        <select
          className="border p-2 rounded w-full"
          onChange={(e) => setPaidByFilter(e.target.value)}
          value={paidByFilter}
        >
          <option value="">Ödəmə növləri</option>
          {paidBy?.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      {/* Summary */}
      <div className="text-sm text-gray-600">
        <span className="mr-4">Alıcı sayı: <strong>{countOfTickets}</strong></span>
        <span>Cəmi məbləğ: <strong>{sumOfPrices} ₼</strong></span>
      </div>

      {/* Tickets List - Responsive */}
      <div className="w-full overflow-x-auto rounded-xl shadow">
        <table className="min-w-max w-full bg-white">
          <thead>
            <tr className="bg-gray-200 text-left text-sm font-semibold text-gray-700 whitespace-nowrap">
              <th className="p-4">Alıcı ({countOfTickets})</th>
              <th className="p-4">Bilet Növü</th>
              <th className="p-4">Məbləğ ({sumOfPrices}) ₼</th>
              <th className="p-4">Status</th>
              <th className="p-4">Ödəmə növü</th>
              <th className="p-4">Tarix</th>
              <th className="p-4">Əməliyyatlar</th>
            </tr>
          </thead>
          <tbody>
            {filteredTickets.map((ticket) => (
              <tr key={ticket.id} className="border-t text-sm hover:bg-gray-50 whitespace-nowrap">
                <td className="p-4">{ticket?.name}</td>
                <td className="p-4">{ticket?.ticketTypeId?.name?.az}</td>
                <td className="p-4">{ticket?.ticketTypeId?.price} ₼</td>
                <td className="p-4">{ticket?.paymentStatus ?? "naməlum"}</td>
                <td className="p-4">{ticket?.paidBy}</td>
                <td className="p-4">{ticket?.createdAt}</td>
                <td className="p-4 space-x-2">
                  <Link to={ticket?.qrCodeUrl} replace className="text-blue-600 hover:underline">Bax</Link>
                  <Link to={`/dashboard/${eventId}/tickets/${ticket?._id}`} className="text-yellow-600 hover:underline">Düzəlt</Link>
                  <button onClick={() => onDelete(eventId, ticket?._id)} className="text-red-600 hover:underline">Sil</button>
                </td>
              </tr>
            ))}
            {filteredTickets.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center p-4 text-gray-500">
                  Heç bir nəticə tapılmadı.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default TicketTable;
